import ConfiguratorService from "src/services/configuratorService";

const useConfiguratorService = () => {
  return new ConfiguratorService();
};

export default useConfiguratorService;
